<div class="container-fluid">
    <div class="card primary-card">
        <div>
            <div class="row p-4">
                <h3 class="card-title"><b>Capture</b> Client</h3>
            </div>
            <mat-tab-group [(selectedIndex)]="selectedIndex" mat-stretch-tabs (selectedTabChange)="stepChanged($event)">
                <mat-tab #creditCheck [disabled]="!creditCheck.isActive" label="Credit Report">
                    <app-credit-report (updateStepEvent)="updateStep()"></app-credit-report>
                </mat-tab>
                <mat-tab #clientDetails [disabled]="!clientDetails.isActive"  label="Client Details">
                    <app-personal-details #personalDetails (updateStepEvent)="updateStep()"></app-personal-details>
                </mat-tab>
                <mat-tab #nextOfKin [disabled]="!nextOfKinDetails.isActive"  label="Next of Kin Details">
                    <app-next-of-kin-details #nextOfKinDetails (updateStepEvent)="updateStep()"></app-next-of-kin-details>
                </mat-tab>
                <mat-tab #bankEmployerDetails [disabled]="!bankEmployerDetails.isActive" label="Bank and Employer Details">
                    <app-bank-employer-details (updateStepEvent)="updateStep()" (eventChange)="onChange()">
                    </app-bank-employer-details>
                </mat-tab>
                <mat-tab #uploadDocuments [disabled]="!uploadDocuments.isActive" label="Upload Client Documents">
                    <app-upload-documents (updateStepEvent)="updateStep()" (previousStepEvent)="previousStep()">
                    </app-upload-documents>
                </mat-tab>
                <mat-tab #finished [disabled]="!finished.isActive" label="Finished">
                    <app-client-capture-final (updateStepEvent)="updateStep()" (previousStepEvent)="previousStep()">
                    </app-client-capture-final>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>